import React, { useState } from "react";
import { bool } from "prop-types";
import { push } from "connected-react-router";
import { useDispatch, useSelector } from "react-redux";
import { Field, Form, Formik } from "formik";
// import { useGetAccount } from "hooks/useAccounts";
import moment from "moment";
import MainContainer from "pages/_components/MainContainer";
import { DesktopButtons, MobileButtons, ResponsiveHeader } from "pages/_components/header";
import Notification from "pages/_components/Notification";
import Selector from "pages/_components/fields/formik/Selector";
import FieldLabel from "pages/_components/fields/FieldLabel";
import AmountField from "pages/_components/fields/formik/AmountField";
import Date from "pages/_components/fields/DateField";
import Button from "pages/_components/Button";
import TextField from "pages/_components/fields/TextField";
import ProductSelector from "pages/_components/fields/formik/FormikProductSelector";
import Beneficiaries from "pages/echeck/components/Beneficiaries";
import { useEcheckAccountSelector } from "pages/echeck/hooks/useEcheckAccouts";
import { actions as notificationActions } from "reducers/notification";
import { actions as echeckActions, types } from "reducers/echecks";
import { characters, createEmisionEcheqList } from "util/echecks";
import { transferReasons } from "util/transfer";
import * as i18n from "util/i18n";
import * as Yup from "yup";
import useSchema from "hooks/useSchema";
import { useLocation } from "react-router-dom";
import { getInteger } from "util/config";
import Action from "pages/_components/Action";
import GridTable from "pages/_components/GridTable/GridTable";
import CustomButton from "pages/_components/CustomButton/CustomButton";
import { isIOS } from "react-device-detect";
import AmountEchecks from "../components/AmountEchecks";

const FORM_ID = "echecks.emit";
const ARS = "ARS";
const CHECKING_ACCOUNT = "CC";

const EmitEcheckPage = ({ isDesktop }) => {
    const dispatch = useDispatch();
    const { state: locationState } = useLocation();
    const { accountOptions, fetching } = useEcheckAccountSelector(ARS, CHECKING_ACCOUNT);
    const { echeqsToEmit, emitEcheqData } = useSelector((state) => state.echecks);
    const { stringRequired, numberRequired } = useSchema();
    // const emisionModeOptions = i18n.formatOption(emisionModes, "echecks.modes");
    const characterOptions = i18n.formatOption(characters, "echecks.characters");
    const conceptOptions = i18n.formatOption(transferReasons, "transfer.reasons");
    const placeholder = i18n.get("global.select");
    const hasBeneficiary = emitEcheqData?.beneficiary?.reference;
    const [selectedAccountId, setSelectedAccountId] = useState(locationState?.accountId ?? "");
    const [badAmount, setBadAmount] = useState(true);
    // const account = useGetAccount(selectedAccountId);
    const maxDays = getInteger("time.frecuency.max.days", 365);

    const changeEcheqType = (date, setFieldValue) => {
        const today = moment().startOf("day");
        const selectedDate = moment(date).startOf("day");

        if (Math.abs(today.diff(selectedDate, "days")) > 0) {
            setFieldValue("type", "CPD");
        } else {
            setFieldValue("type", "CC");
        }
    };

    // const onChangeEmitMode = (option, setFieldValue) => {
    //     if (option.value !== "MULT") {
    //         setFieldValue("quantity", 1);
    //     }
    //     dispatch(checkActions.updateListEcheqToEmit([]));
    // };

    const initialValues = {
        idAccount: emitEcheqData?.idAccount || locationState?.accountId || "",
        modes: emitEcheqData?.modes || "INDI",
        concept: emitEcheqData?.concept || "VAR",
        motive: emitEcheqData?.motive || "",
        character: emitEcheqData?.character || characterOptions[0].value,
        sendEmail: emitEcheqData?.sendEmail || false,
        email: emitEcheqData?.email || "",
        emailText: emitEcheqData?.emailText || "",
        date: emitEcheqData?.modes !== "PERS" && echeqsToEmit[0]?.date ? echeqsToEmit[0]?.date : moment().toDate(),
        quantity: emitEcheqData?.modes !== "PERS" && echeqsToEmit?.length ? echeqsToEmit?.length : 1,
        reference: emitEcheqData?.modes !== "PERS" && echeqsToEmit[0]?.reference ? echeqsToEmit[0]?.reference : "",
        referencevalue:
            emitEcheqData?.modes !== "PERS" && echeqsToEmit[0]?.referencevalue ? echeqsToEmit[0]?.referencevalue : "",
        amountField: {
            amount:
                emitEcheqData?.modes !== "PERS" && echeqsToEmit[0]?.amount
                    ? echeqsToEmit[0]?.amount * echeqsToEmit.length
                    : "",
        },
        type: emitEcheqData?.modes !== "PERS" && echeqsToEmit?.length ? echeqsToEmit[0]?.type : "CC",
        mode: true,
    };

    const handleSubmit = (values) => {
        if (!emitEcheqData?.beneficiary?.reference) {
            dispatch(notificationActions.showNotification("echecks.empty.beneficiary", "error", ["echecks/emit"]));
        } else {
            const {
                idAccount,
                modes,
                concept,
                motive,
                character,
                mode,
                sendEmail,
                email,
                emailText,
                amountField,
            } = values;
            const formData = {
                idAccount,
                modes,
                concept,
                motive,
                character,
                mode: mode ? "Cruzado" : "",
                sendEmail,
                email,
                emailText,
                amount: {
                    quantity: amountField.amount,
                    currency: "ARS",
                },
            };
            let echeqList = [...echeqsToEmit];

            if (values.modes !== "PERS") {
                echeqList = createEmisionEcheqList(values);
            }

            if (echeqsToEmit.length === 0 && values.modes === "PERS") {
                dispatch(
                    notificationActions.showNotification(i18n.get(`${FORM_ID}.empty.echeq.list.message`), "error", [
                        "echecks/emit",
                    ]),
                );
            } else if (!values.confirmation && values.modes === "PERS" && values.amountField.amount) {
                dispatch(
                    notificationActions.showNotification(i18n.get(`${FORM_ID}.confirmation.message`), "warning", [
                        "echecks/emit",
                    ]),
                );
            } else {
                dispatch(echeckActions.echeqEmitData({ formData, echeqList }));
                dispatch(push("/echecks/emit/confirm"));
            }
        }
    };

    const emitEcheckValidation = Yup.lazy((values) => {
        let validate = {
            idAccount: stringRequired,
            concept: stringRequired,
            character: stringRequired,
            mode: stringRequired,
            motive: stringRequired,
        };

        if (values.modes !== "PERS") {
            validate = {
                ...validate,
                amountField: Yup.object()
                    .shape({
                        amount: numberRequired,
                    })
                    .test("amountField", "Monto incorrecto", () => {
                        /* if (account?.availableBalance < amount.amount) {
                            dispatch(
                                notificationActions.showNotification(i18n.get("echeq.incorrect.amount"), "error", [
                                    "echecks/emit",
                                ]),
                            );
                            setBadAmount(true);
                            return false;
                        } */
                        setBadAmount(false);
                        return true;
                    }),
                quantity: Yup.number()
                    .min(1, i18n.get(`${FORM_ID}.min.quantity.required`))
                    .max(10, i18n.get(`${FORM_ID}.max.quantity.required`))
                    .required(i18n.get(`${FORM_ID}.error.required`)),
                date: stringRequired,
            };
        }

        if (values.sendEmail) {
            validate = {
                ...validate,
                email: stringRequired,
                emailText: stringRequired,
            };
        }

        return Yup.object().shape(validate);
    });

    return (
        <>
            <Notification scopeToShow="echecks/emit" />
            <Notification scopeToShow="echecks/beneficary" />
            <ResponsiveHeader id="echecks.emit">
                <DesktopButtons>
                    <CustomButton
                        func={() => dispatch(push("/echecks/requestAmount"))}
                        className="btn btn-primary btn-block"
                        icon="images/figma/icon/nuevo.svg"
                        text="echecks.request"
                        textType="I18N"
                    />
                </DesktopButtons>
                <MobileButtons
                    image={isIOS ? "images/figma/icon/menu-ios-white.svg" : "images/figma/icon/menu-ios.svg"}>
                    <Action labelKey="echecks.request" to="/echecks/requestAmount" />
                </MobileButtons>
            </ResponsiveHeader>
            <MainContainer classname="echeck" showLoader={fetching}>
                <AmountEchecks selectedAccountId={selectedAccountId} />
                <Formik
                    initialValues={initialValues}
                    onSubmit={handleSubmit}
                    validationSchema={emitEcheckValidation}
                    validateOnChange>
                    {({ values, setFieldValue }) => (
                        <Form>
                            <GridTable className="form">
                                <GridTable.Container columns={12} columnsTemplate="fixed">
                                    <GridTable.Data className="required" columnStart={2} columnWidth={10}>
                                        <Field
                                            component={ProductSelector}
                                            idForm={FORM_ID}
                                            name="idAccount"
                                            label={`${i18n.get("echecks.emit.emision.label")}`}
                                            placeholder={placeholder}
                                            data={{ emptyOptionLabel: "", options: accountOptions }}
                                            onChange={(id) => setSelectedAccountId(id)}
                                        />
                                    </GridTable.Data>
                                    <GridTable.Data
                                        columnStart={2}
                                        columnWidth={10}
                                        rowStart={2}
                                        className="form-group">
                                        <FieldLabel labelKey={`${FORM_ID}.beneficiary`} />
                                    </GridTable.Data>
                                    <GridTable.Data
                                        columnStart={2}
                                        columnWidth={10}
                                        rowStart={3}
                                        className="form-group">
                                        <Beneficiaries
                                            isDesktop={isDesktop}
                                            idForm={FORM_ID}
                                            setEmailValues={setFieldValue}
                                            beneficiaryData={emitEcheqData}
                                            actionType={types.EMIT_ECHEQ_BENEFICIARY}
                                        />
                                    </GridTable.Data>
                                    {values.sendEmail && (
                                        <>
                                            <GridTable.Data columnStart={2} columnWidth={5} rowStart={4}>
                                                <Field
                                                    component={TextField}
                                                    idForm={FORM_ID}
                                                    name="email"
                                                    type="email"
                                                    disabled={!hasBeneficiary}
                                                    hidePlaceholder
                                                />
                                            </GridTable.Data>
                                            <GridTable.Data columnStart={7} columnWidth={5} rowStart={4}>
                                                <Field
                                                    component={TextField}
                                                    idForm={FORM_ID}
                                                    name="emailText"
                                                    disabled={!hasBeneficiary}
                                                    maxLength="150"
                                                    type="text"
                                                    hidePlaceholder
                                                />
                                            </GridTable.Data>
                                        </>
                                    )}
                                    <GridTable.Data className="required" columnStart={2} columnWidth={5} rowStart={5}>
                                        {/* <Col xs={12} md={6}>
                                    <Field
                                        component={Selector}
                                        idForm={FORM_ID}
                                        name="modes"
                                        disabled={!hasBeneficiary}
                                        options={emisionModeOptions.map((option) => {
                                            if (option.value === "IND") {
                                                return option;
                                            }
                                            return { ...option, disabled: true };
                                        })}
                                        placeholder={placeholder}
                                        onChange={(option) => onChangeEmitMode(option, setFieldValue)}
                                    />
                                </Col> */}
                                        <Field
                                            component={AmountField}
                                            labelText={`${i18n.get(`${FORM_ID}.amountField.label`)}`}
                                            idForm={FORM_ID}
                                            name="amountField"
                                            disable={!hasBeneficiary}
                                            data={{ options: [{ id: 1, label: i18n.get(`currency.label.${ARS}`) }] }}
                                            clearable={false}
                                        />
                                    </GridTable.Data>
                                    <GridTable.Data className="required" columnStart={7} columnWidth={5} rowStart={5}>
                                        <Field
                                            component={Date}
                                            idForm={FORM_ID}
                                            name="date"
                                            labelKey={`${i18n.get(`${FORM_ID}.date.label`)}`}
                                            labelText={`${i18n.get(`${FORM_ID}.date.label`)}`}
                                            disabled={!hasBeneficiary}
                                            handleChange={(date) => changeEcheqType(date, setFieldValue)}
                                            startDate={new Date()}
                                            minDate={new Date()}
                                            maxDate={moment().add(maxDays, "days")}
                                            hidePlaceholder
                                            noEdit
                                        />
                                    </GridTable.Data>
                                    <GridTable.Data className="required" columnStart={2} columnWidth={5} rowStart={6}>
                                        <Field
                                            component={Selector}
                                            idForm={FORM_ID}
                                            name="character"
                                            label={`${i18n.get(`${FORM_ID}.character.label`)}`}
                                            disabled={!hasBeneficiary}
                                            options={characterOptions}
                                            placeholder={placeholder}
                                        />
                                    </GridTable.Data>
                                    <GridTable.Data columnStart={7} columnWidth={5} rowStart={6}>
                                        <Field
                                            component={Selector}
                                            idForm={FORM_ID}
                                            name="concept"
                                            disabled={!hasBeneficiary}
                                            options={conceptOptions}
                                            placeholder={placeholder}
                                        />
                                    </GridTable.Data>
                                    <GridTable.Data className="required" columnStart={2} columnWidth={5} rowStart={7}>
                                        <Field
                                            component={TextField}
                                            idForm={FORM_ID}
                                            name="motive"
                                            disabled={!hasBeneficiary}
                                            type="text"
                                            maxLength="150"
                                            hidePlaceholder
                                        />
                                    </GridTable.Data>
                                    <GridTable.Data columnStart={7} columnWidth={5} rowStart={7}>
                                        {/* <Col xs={12} md={6}>
                                    <Field
                                        component={TextField}
                                        idForm={FORM_ID}
                                        name="type"
                                        disabled
                                        type="text"
                                        hidePlaceholder
                                    />
                                </Col> */}
                                        <Field
                                            component={TextField}
                                            idForm={FORM_ID}
                                            name="reference"
                                            disabled={!hasBeneficiary}
                                            maxLength="100"
                                            type="text"
                                            hidePlaceholder
                                        />
                                    </GridTable.Data>
                                    {/* <GridTable.Data
                                        className="echeck echeck-checkbox"
                                        columnStart={2}
                                        columnWidth={5}
                                        rowStart={8}>
                                        <FieldLabel labelKey={`${FORM_ID}.mode`} />
                                        <Field
                                            component={Checkbox}
                                            idForm={FORM_ID}
                                            name="mode"
                                            labelText={`${FORM_ID}.cross`}
                                            disabled
                                        />
                                    </GridTable.Data> */}
                                    {/* <Col xs={12} md={6}>
                                    <Field
                                        component={TextField}
                                        idForm={FORM_ID}
                                        name="referencevalue"
                                        disabled={!hasBeneficiary}
                                        maxLength="50"
                                        type="text"
                                        hidePlaceholder
                                    />
                                </Col> */}
                                    {values.modes === "MULT" && (
                                        <GridTable.Data columnStart={7} columnWidth={5} rowStart={8}>
                                            <Field
                                                component={TextField}
                                                idForm={FORM_ID}
                                                name="quantity"
                                                disabled={!hasBeneficiary}
                                                type="number"
                                                max="10"
                                                hidePlaceholder
                                            />
                                        </GridTable.Data>
                                    )}
                                </GridTable.Container>
                            </GridTable>
                            <GridTable>
                                <GridTable.Container columns={12} columnsTemplate="fixed" className="form-actions">
                                    <GridTable.Data columnStart={isDesktop ? 5 : 1} columnWidth={isDesktop ? 4 : 12}>
                                        <Button
                                            type="submit"
                                            className="btn-primary"
                                            label="global.continue"
                                            disabled={
                                                !values.idAccount ||
                                                !hasBeneficiary ||
                                                !values.motive ||
                                                !values.amountField.amount ||
                                                badAmount
                                            }
                                        />
                                    </GridTable.Data>
                                </GridTable.Container>
                            </GridTable>
                        </Form>
                    )}
                </Formik>
            </MainContainer>
        </>
    );
};

EmitEcheckPage.propTypes = {
    isDesktop: bool.isRequired,
};

export default EmitEcheckPage;
